// **
//   All of the routes for SideNav in the DigitalPass are added here,
//   You can add a new route, customize the routes and delete the routes here.

//   Once you add a new route on this file it will be visible automatically on
//   the Sidenav.

//   For adding a new route you can follow the existing routes in the routes array.
//   1. The `type` key with the `collapse` value is used for a route.
//   2. The `type` key with the `title` value is used for a title inside the Sidenav.
//   3. The `type` key with the `divider` value is used for a divider between Sidenav items.
//   4. The `name` key is used for the name of the route on the Sidenav.
//   5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
//   6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
//   7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
//   inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
//   8. The `route` key is used to store the route location which is used for the react router.
//   9. The `href` key is used to store the external links location.
//   10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
//   10. The `component` key is used to store the component of its route.
// */
// DigitalPass components
//Admin Dashboard
import React, { lazy } from "react";

import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import PaymentIcon from "@mui/icons-material/Payment";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AirplanemodeInactiveIcon from "@mui/icons-material/AirplanemodeInactive";
import LogoutIcon from "@mui/icons-material/Logout";
// Lazy loading components
const Logout = lazy(() => import("components/Auth/Logout"));
const DashboardLayout = lazy(() => import("layout/LayoutContainers/DashboardLayout"));
const NewApplication = lazy(() => import("components/Dashboard/Applications/NewApplication"));
const ApplicationList = lazy(() => import("components/Dashboard/Applications/ApplicationList"));
const ViewApplication = lazy(() => import("components/Dashboard/Applications/ViewApplication"));
const ExamForm = lazy(() => import("components/Dashboard/Applications/Exam/ExamForm"));
const TransactionList = lazy(() => import("components/Dashboard/Transactions/TransactionList"));
const DigitalPassList = lazy(() => import("components/Dashboard/Digital Passes/DigitalPassList"));
const ViewDigitalPass = lazy(() => import("components/Dashboard/Digital Passes/ViewDigitalPass"));
const SikapList = lazy(() => import("components/Dashboard/Sikaps/All Sikaps/SikapsList"));
const ViewSikap = lazy(() => import("components/Dashboard/Sikaps/View Sikap"));
const SikapExamForm = lazy(() => import("components/Dashboard/Sikaps/SikapExamForm"));
const SikapTransactionList = lazy(() =>
  import("components/Dashboard/Sikaps/SikapTransactions/SikapsTransactionList")
);

// const VehicleList = lazy(() => import("components/Dashboard/Vehicles/VehicleList"));
// const ViewVehicle = lazy(() => import("components/Dashboard/Vehicles/ViewVehicle"));
// const ViewSticker = lazy(() => import("components/Dashboard/Stickers/Sticker/ViewSticker"));
// const StickerList = lazy(() => import("components/Dashboard/Stickers/StickerList/StickerList"));
// const VehicleTransactionList = lazy(() => import("components/Dashboard/Vehicles/VehicleTransactions/VehicleTransactionList"));

let userRoutes = [
  {
    type: "title",
    title: "DigitalPortpass",
    key: "digitalpass-pages",
  },
  {
    type: "collapse",
    name: "Active Portpass",
    key: "/digitalpass/active",
    route: "/digitalpass/active",
    component: (
      <DashboardLayout>
        <DigitalPassList key="active" type="active" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeActiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Inactive Portpass",
    key: "/digitalpass/inactive",
    route: "/digitalpass/inactive",
    component: (
      <DashboardLayout>
        <DigitalPassList key="inactive" type="inactive" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeInactiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "All Portpass",
    key: "/digitalpass/all",
    route: "/digitalpass/all",
    component: (
      <DashboardLayout>
        <DigitalPassList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/digitalpass/:_id",
    key: "/digitalpass/:_id",
    component: (
      <DashboardLayout>
        <ViewDigitalPass />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-00" },

  {
    type: "title",
    title: "Applications",
    key: "Applications",
  },
  {
    type: "collapse",
    name: "New Application",
    key: "/applications/new",
    route: "/applications/new",
    component: (
      <DashboardLayout>
        <NewApplication />
      </DashboardLayout>
    ),
    icon: <AddBusinessIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Submitted Applications",
    key: "/applications/all",
    route: "/applications/all",
    component: (
      <DashboardLayout>
        <ApplicationList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
  },
  {
    type: null,
    route: "/applications/:id",
    key: "/applications/:id",
    component: (
      <DashboardLayout>
        <ViewApplication />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-50" },
  {
    type: "title",
    title: "Sikaps",
    key: "sikaps-pages",
  },

  {
    type: "collapse",
    name: "All Sikaps",
    key: "/sikaps/all",
    route: "/sikaps/all",
    component: (
      <DashboardLayout>
        <SikapList key="all" type="all" />
      </DashboardLayout>
    ),

    noCollapse: true,
    icon: <FormatListBulletedIcon />,
  },
  {
    type: null,
    route: "/sikaps/view/:id",
    key: "/sikaps/view/:id",
    component: (
      <DashboardLayout>
        <ViewSikap />
      </DashboardLayout>
    ),
  },
  {
    type: null,
    route: "/sikaps/exam",
    key: "/sikaps/exam",
    component: (
      <DashboardLayout>
        <SikapExamForm />
      </DashboardLayout>
    ),
  },
  //   { type: "divider", key: "divider-9", status: 2 },
  // { type: "title", title: "Vehicles", key: "vehicles-pages", status: 2 },
  // {
  //   type: "collapse",
  //   name: "My Vehicles",
  //   key: "/vehicles/all",
  //   route: "/vehicles/all",
  //   component: (
  //     <DashboardLayout>
  //       <VehicleList key="all" type="all" />
  //     </DashboardLayout>
  //   ),
  //   icon: <FormatListBulletedIcon />,
  //   noCollapse: true,
  //   status: 2,
  // },
  // {
  //   type: null,
  //   route: "/vehicle/:id",
  //   key: "/vehicle/:id",
  //   component: (
  //     <DashboardLayout>
  //       <ViewVehicle />
  //     </DashboardLayout>
  //   ),
  //   status: 2,
  // },
  // {
  //   type: null,
  //   route: "/vehicle/sticker/:id",
  //   key: "/vehicle/sticker/:id",
  //   component: (
  //     <DashboardLayout>
  //       <ViewSticker />
  //     </DashboardLayout>
  //   ),
  //   status: 2,
  // },
  // { type: "divider", key: "divider-15" },
  // {
  //   type: "title",
  //   title: "Stickers",
  //   key: "sticker-pages",
  // },
  // {
  //   type: "collapse",
  //   name: "All Stickers",
  //   key: "/stickers/all",
  //   route: "/stickers/all",
  //   component: (
  //     <DashboardLayout>
  //       <StickerList key="all" type="all" />
  //     </DashboardLayout>
  //   ),
  //   icon: <FormatListBulletedIcon />,
  //   noCollapse: true,
  //   status: 2,
  // },
  // {
  //   type: null,
  //   route: "/vehicle/sticker/:id",
  //   key: "/vehicle/sticker/:id",
  //   component: (
  //     <DashboardLayout>
  //       <ViewSticker />
  //     </DashboardLayout>
  //   ),
  //   status: 2,
  // },
  { type: "divider", key: "divider-1" },

  {
    type: "title",
    title: "Transactions",
    key: "transaction-pages",
  },
  {
    type: "collapse",
    name: "Digital Portpass Transactions",
    key: "/digitalpasses/transaction/all",
    route: "/digitalpasses/transaction/all",
    component: (
      <DashboardLayout>
        <TransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Vehicle Transactions",
  //   key: "/vehicle/transaction/all",
  //   route: "/vehicle/transaction/all",
  //   component: (
  //     <DashboardLayout>
  //       <VehicleTransactionList key="all" type="all" />
  //     </DashboardLayout>
  //   ),
  //   icon: <PaymentIcon />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Sikaps Transactions",
    key: "/sikaps/transaction/all",
    route: "/sikaps/transaction/all",
    component: (
      <DashboardLayout>
        <SikapTransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  {
    type: null,
    route: "/applications/examform",
    key: "exam-form",
    component: (
      <DashboardLayout>
        <ExamForm />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-2" },
  { type: "title", title: "Profile", key: "profile-pages" },

  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "home",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-3" },
];

export default userRoutes;
